window.dataLayer = window.dataLayer || [];

function initEpicEvents() {
  //EPIC page view events
  if (window.location.pathname == '/account') {
    window.dataLayer.push({
      event: 'epic_dasboard_page_view',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname == '/pages/my-brands' || window.location.pathname == '/pages/my-preferences') {
    window.dataLayer.push({
      event: 'epic_my_brands_page_view',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname == '/pages/my-orders') {
    window.dataLayer.push({
      event: 'epic_orders_page_view',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname.includes('/account/orders/')) {
    let order_number_element = document.querySelector('.view-order-link');
    if (!order_number_element) return false;
    let order_number = order_number_element.textContent;
    if (!order_number) return false;
    window.dataLayer.push({
      event: 'epic_order_page_view',
      source: 'sf9_epic',
      order_number: order_number
    });
  }

  if (window.location.pathname == '/account/login') {
    window.dataLayer.push({
      event: 'epic_login_page_view',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname == '/pages/petstop-loyalty') {
    window.dataLayer.push({
      event: 'epic_loyalty_page_view',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname == '/pages/buy-it-again') {
    window.dataLayer.push({
      event: 'epic_buy_it_again_page_view',
      source: 'sf9_epic'
    });
  } //EPIC click events


  let view_loyalty_card_links = document.querySelectorAll('.view-loyalty-card');
  view_loyalty_card_links.forEach(view_loyalty_card_link => {
    view_loyalty_card_link.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_view_loyalty_card_click',
        source: 'sf9_epic'
      });
    });
  });
  let return_to_dashboard_links = document.querySelectorAll('.return-to-dashboard-link');
  return_to_dashboard_links.forEach(return_to_dashboard_link => {
    return_to_dashboard_link.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_return_to_dashboard_click',
        source: 'sf9_epic'
      });
    });
  });
  let manage_my_brands_btns = document.querySelectorAll('.js-open-brands-popup');
  manage_my_brands_btns.forEach(manage_my_brands_btn => {
    manage_my_brands_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_manage_my_brands_click',
        source: 'sf9_epic'
      });
    });
  });
  let manage_my_brands_pdp_btns = document.querySelectorAll('.brand-manage');
  manage_my_brands_pdp_btns.forEach(manage_my_brands_pdp_btn => {
    let product_id = manage_my_brands_pdp_btn.getAttribute('data-product-id');
    if (!product_id) return false;
    manage_my_brands_pdp_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_manage_my_brands_pdp_click',
        source: 'sf9_epic',
        product_id: product_id
      });
    });
  });
  let follow_brand_btns = document.querySelectorAll('.js-add-brand');
  follow_brand_btns.forEach(follow_brand_btn => {
    let brand = follow_brand_btn.getAttribute('data-brand-name');
    if (!brand) return false;
    follow_brand_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_follow_brand_click',
        source: 'sf9_epic',
        brand: brand
      });
    });
  });
  let follow_brand_pdp_btns = document.querySelectorAll('.follow-brand-pdp-button');
  follow_brand_pdp_btns.forEach(follow_brand_pdp_btn => {
    let brand = follow_brand_pdp_btn.getAttribute('data-brand-name');
    if (!brand) return false;
    follow_brand_pdp_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_follow_brand_click_pdp',
        source: 'sf9_epic',
        brand: brand
      });
    });
  });
  let follow_brand_plp_btns = document.querySelectorAll('.follow-brand-plp-button');
  follow_brand_plp_btns.forEach(follow_brand_plp_btn => {
    let brand = follow_brand_plp_btn.getAttribute('data-brand-name');
    if (!brand) return false;
    follow_brand_plp_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_follow_brand_click_plp',
        source: 'sf9_epic',
        brand: brand
      });
    });
  });
  let buy_it_again_sorting_selects = document.querySelectorAll('.buy-it-again-sorting');
  buy_it_again_sorting_selects.forEach(buy_it_again_sorting_select => {
    buy_it_again_sorting_select.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_use_sorting_on_buy_it_again',
        source: 'sf9_epic'
      });
    });
  });
  let view_all_orders_btns = document.querySelectorAll('.view-all-orders');
  view_all_orders_btns.forEach(view_all_orders_btn => {
    view_all_orders_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_view_all_orders_click',
        source: 'sf9_epic'
      });
    });
  });
  let view_order_btns = document.querySelectorAll('.epic-view-order-link');
  view_order_btns.forEach(view_order_btn => {
    let order_number = view_order_btn.getAttribute('data-order-number');
    if (!order_number) return false;
    view_order_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_view_order_click',
        source: 'sf9_epic',
        order_number: order_number
      });
    });
  });
  let see_dashboard_links = document.querySelectorAll('.see-dashboard-link');
  see_dashboard_links.forEach(see_dashboard_link => {
    see_dashboard_link.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_see_dashboard_click',
        source: 'sf9_epic'
      });
    });
  });
  let create_rewards_card_btns = document.querySelectorAll('[data-register-with-email]');
  create_rewards_card_btns.forEach(create_rewards_card_btn => {
    create_rewards_card_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_create_rewards_card_click',
        source: 'sf9_epic'
      });
    });
  });
  let register_with_card_btns = document.querySelectorAll('[data-register-with-card]');
  register_with_card_btns.forEach(register_with_card_btn => {
    register_with_card_btn.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'epic_register_with_card_click',
        source: 'sf9_epic'
      });
    });
  });
  let my_account_header_links = document.querySelectorAll('.header__icon--account-link');
  my_account_header_links.forEach(my_account_header_link => {
    my_account_header_link.addEventListener('click', e => {
      sessionStorage.setItem('from_header_account_click', '1');
      window.dataLayer.push({
        event: 'epic_my_account_header_click',
        source: 'sf9_epic'
      });
    });
  }); //EPIC behavior events

  let login_form = document.getElementById('customer_login');

  if (login_form) {
    login_form.addEventListener('submit', e => {
      sessionStorage.setItem('login_form_submitted', '1');
    });
  }

  const cameFromHeaderClick = sessionStorage.getItem('from_header_account_click') === '1';
  const loginFormSubmitted = sessionStorage.getItem('login_form_submitted') === '1';

  if (window.location.pathname == '/account' && loginFormSubmitted) {
    window.dataLayer.push({
      event: 'epic_login_form_submitted',
      source: 'sf9_epic'
    });
  }

  if (window.location.pathname == '/account' && cameFromHeaderClick && loginFormSubmitted) {
    window.dataLayer.push({
      event: 'epic_account_header_click_login',
      source: 'sf9_epic'
    });
    sessionStorage.removeItem('from_header_account_click');
    sessionStorage.removeItem('login_form_submitted');
    sessionStorage.removeItem('register_form_submitted');
  }

  let register_form = document.getElementById('create_customer');

  if (register_form) {
    register_form.addEventListener('submit', e => {
      sessionStorage.setItem('register_form_submitted', '1');
    });
  }

  const registerFormSubmitted = sessionStorage.getItem('register_form_submitted') === '1';
  const registerSuccess = document.querySelector('.register-success');

  if (registerSuccess && registerFormSubmitted) {
    window.dataLayer.push({
      event: 'epic_register_form_submitted',
      source: 'sf9_epic'
    });
  }

  if (registerSuccess && registerFormSubmitted && cameFromHeaderClick) {
    window.dataLayer.push({
      event: 'epic_account_header_click_register',
      source: 'sf9_epic'
    });
    sessionStorage.removeItem('from_header_account_click');
    sessionStorage.removeItem('register_form_submitted');
    sessionStorage.removeItem('login_form_submitted');
  }

  let isLoggedInCustomer = document.querySelector('.logged-in-customer');

  if (isLoggedInCustomer) {
    sessionStorage.removeItem('from_header_account_click');
    sessionStorage.removeItem('register_form_submitted');
    sessionStorage.removeItem('login_form_submitted');
  } //EPIC click events (dynamic elements)


  let epic_brands_events_sections = document.querySelectorAll('.epic-brands-events');
  epic_brands_events_sections.forEach(epic_brands_events_section => {
    epic_brands_events_section.addEventListener('click', e => {
      const elem = e.target;

      if (elem.classList.contains('event-brand-link')) {
        let href = elem.getAttribute('href');
        let brand = elem.getAttribute('data-brand-name');
        if (!brand || !href) return false;
        window.dataLayer.push({
          event: 'epic_view_brand_collection',
          source: 'sf9_epic',
          brand: brand,
          collection_url: href
        });
      }
    });
  });
  let epic_manage_brands_events_sections = document.querySelectorAll('.manage-brands-events');
  epic_manage_brands_events_sections.forEach(epic_manage_brands_events_section => {
    epic_manage_brands_events_section.addEventListener('click', e => {
      const elem = e.target;

      if (elem.classList.contains('js-remove-brand')) {
        let brand = elem.getAttribute('data-brand-name');
        if (!brand) return false;
        window.dataLayer.push({
          event: 'epic_unfollow_brand_click',
          source: 'sf9_epic',
          brand: brand
        });
      }
    });
  });
  let products_events_sections = document.querySelectorAll('.epic-products-events');
  products_events_sections.forEach(products_events_section => {
    products_events_section.addEventListener('click', e => {
      const elem = e.target;
      let link = elem.closest('a');

      if (elem.classList.contains('epic-product-link')) {
        let product_id = elem.getAttribute('data-product-id');
        if (!product_id) return false;
        window.dataLayer.push({
          event: 'epic_view_product_link_click',
          source: 'sf9_epic',
          product_id: product_id
        });
      } else if (link && link.classList.contains('epic-product-link')) {
        let product_id = link.getAttribute('data-product-id');
        if (!product_id) return false;
        window.dataLayer.push({
          event: 'epic_view_product_link_click',
          source: 'sf9_epic',
          product_id: product_id
        });
      }
    });
  });
}

if (document.readyState === 'complete') {
  initEpicEvents();
} else {
  window.addEventListener('load', initEpicEvents);
} //EPIC action events


let is_epic_page = document.querySelector('.epic-page-events') ? true : false;

if (is_epic_page) {
  document.addEventListener('ajaxProduct:added', e => {
    let product = e.detail.product;
    let requested_product = e.detail.requested_product;
    if (!product) return false;

    if (product.product_id) {
      let item_id = product.product_id;
      let item_name = product.product_title;
      let item_brand = product.vendor;
      let item_category = product.product_type;
      let item_variant = product.title;
      let item_variant_id = product.variant_id;
      let price = product.final_price;
      window.dataLayer.push({
        event: 'epic_add_to_cart',
        ecommerce: {
          currency: 'EUR',
          value: parseFloat(price / 100),
          items: [{
            item_id: String(item_id),
            item_name: item_name,
            item_brand: item_brand,
            item_category: item_category,
            item_variant: item_variant,
            item_variant_id: String(item_variant_id),
            price: parseFloat(price / 100),
            quantity: 1
          }]
        },
        source: 'sf9_epic'
      });
    } else if (product.items && requested_product.items && product.items.length == 1) {
      let cart_item = product.items[0];
      let item_id = cart_item.product_id;
      let item_name = cart_item.product_title;
      let item_brand = cart_item.vendor;
      let item_category = cart_item.product_type;
      let item_variant = cart_item.title;
      let item_variant_id = cart_item.variant_id;
      let price = cart_item.final_price;
      const requested_item = requested_product.items.find(item => String(item.id) === String(cart_item.variant_id));
      if (!requested_item) return false;
      let quantity = requested_item.quantity;
      let value = price * quantity;
      window.dataLayer.push({
        event: 'epic_reorder_item',
        ecommerce: {
          currency: 'EUR',
          value: parseFloat(value / 100),
          items: [{
            item_id: String(item_id),
            item_name: item_name,
            item_brand: item_brand,
            item_category: item_category,
            item_variant: item_variant,
            item_variant_id: String(item_variant_id),
            price: parseFloat(price / 100),
            quantity: parseInt(quantity)
          }]
        },
        source: 'sf9_epic'
      });
    } else if (product.items && requested_product.items && product.items.length > 1) {
      let items = [];
      product.items.forEach(product_item => {
        let item_id = product_item.product_id;
        let item_name = product_item.product_title;
        let item_brand = product_item.vendor;
        let item_category = product_item.product_type;
        let item_variant = product_item.title;
        let item_variant_id = product_item.variant_id;
        let price = product_item.final_price;
        const requested_item = requested_product.items.find(item => String(item.id) === String(product_item.variant_id));
        if (!requested_item) return;
        let quantity = requested_item.quantity;
        let cart_item = {
          item_id: String(item_id),
          item_name: item_name,
          item_brand: item_brand,
          item_category: item_category,
          item_variant: item_variant,
          item_variant_id: String(item_variant_id),
          price: parseFloat(price / 100),
          quantity: parseInt(quantity)
        };
        let item_value = cart_item.price * cart_item.quantity;
        items.push(cart_item);
        window.dataLayer.push({
          event: 'epic_reorder_order_item',
          ecommerce: {
            currency: 'EUR',
            value: item_value.toFixed(2),
            items: [{
              item_id: item_id,
              item_name: item_name,
              item_brand: item_brand,
              item_category: item_category,
              item_variant: item_variant,
              item_variant_id: String(item_variant_id),
              price: parseFloat(price / 100),
              quantity: parseInt(quantity)
            }]
          },
          order_number: requested_product.order_number,
          source: 'sf9_epic'
        });
      });
      let value = 0;
      items.forEach(item => {
        let item_value = item.price * item.quantity;
        value = parseFloat(value) + parseFloat(item_value);
      });
      window.dataLayer.push({
        event: 'epic_reorder_order',
        ecommerce: {
          currency: 'EUR',
          value: value.toFixed(2),
          items: items
        },
        order_number: requested_product.order_number,
        source: 'sf9_epic'
      });
    }
  });
}
